import { createContext, PropsWithChildren, useContext } from 'react';
import { Configuration } from '../model/types';

type ConfigurationProviderProps = PropsWithChildren<{
  configuration: Configuration;
}>;

const ConfigurationContext = createContext<Configuration>({} as Configuration);

export function ConfigurationProvider({ configuration, children }: ConfigurationProviderProps) {
  return <ConfigurationContext.Provider value={configuration}>{children}</ConfigurationContext.Provider>;
}

export function useConfigurationContext() {
  return useContext(ConfigurationContext);
}
